import { useQueries, useQuery } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { CoachingSessionDto } from "../../../models/coach/dto/coaching-session.dto";
import { GetCoachCalendarOutputDto } from "../../../models/coach/dto/get-coach-calendar.dto";
import { CourtAvailabilityDto } from "../../../models/court/dto/court-availability.dto";
import { CourtDto } from "../../../models/court/dto/court.dto";


export const COACH_CALENDAR_QUERY_KEY = (coachId: string, start: Date, end: Date) => [...ALL_COACH_CALENDAR_QUERY_KEY(coachId), start, end];
export const ALL_COACH_CALENDAR_QUERY_KEY = (coachId: string) => ['coachCalendar', coachId];

/**
 * `enabled` on the coach id: `CoachDetailsPage` reads it from the `?coach=`
 * hash param (`paramFromWindowLocation`, which returns `null` when the param is
 * absent), so `#/admin/coachDetails` with no query fired
 * `coachs/null/calendar/...`. `useGetCoach` on the same page has always been
 * gated — the asymmetry was the bug.
 */
export const useGetCoachCalendar = (id: string, start: Date, end: Date) => {
    const apiClient = useApiClient();
    return useQuery({
        enabled: Boolean(id),
        queryKey: COACH_CALENDAR_QUERY_KEY(id, start, end),
        queryFn: () => apiClient.fetchApi<GetCoachCalendarOutputDto, {}>({
            endpoint: `coachs/${id}/calendar/${start.toISOString()}/${end.toISOString()}`,
            method: 'GET',
        }),
    });
}

export const useGetCoachWeeklyCalendar = (coachId: string, dates: Date[]) => {
    const apiClient = useApiClient();
    return useQueries({
        queries: dates.map(date => {
            const end = new Date(date.getTime() + 24 * 60 * 60 * 1000 - 0);
            return {
                // Same gate as the single-day query above, and it matters more
                // here: one missing `?coach=` produced SEVEN 404s per page load.
                enabled: Boolean(coachId),
                queryKey: COACH_CALENDAR_QUERY_KEY(coachId, date, end),
                queryFn: () => apiClient.fetchApi<{ availabilities: CourtAvailabilityDto[]; coachingSessions: CoachingSessionDto[]; court: CourtDto }, {}>({
                    endpoint: `coachs/${coachId}/calendar/${date.toISOString()}/${end.toISOString()}`,
                    method: 'GET',
                })
            }
        })
    });
};